export const categories = [
	{
		title: 'Music',
		image:
			'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
	},
	{
		title: 'Technology',
		image:
			'https://images.unsplash.com/photo-1573164713988-8665fc963095?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
	},
	{
		title: 'Sports & Fitness',
		image:
			'https://images.unsplash.com/photo-1607962837359-5e7e89f86776?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
	},
	{
		title: 'Theatre & Arts',
		image:
			'https://images.unsplash.com/photo-1640891175384-e599abd85c6d?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
	},
];

export const teamMembers = [
	{
		image:
			'https://media.licdn.com/dms/image/C5603AQH6uZcoAVRYCg/profile-displayphoto-shrink_400_400/0/1623110116352?e=1713398400&v=beta&t=thgqDyDQFyzO17TSBzqNjmKBgBpWOFGCY1Ge3-7puqY',
		name: 'Joe',
		role: 'Product Manager',
		github: '',
		linkedIn: 'https://www.linkedin.com/in/joe-taylor98/',
		website: 'https://joe-taylor98-portfolio.squarespace.com/',
	},
	{
		image: 'https://avatars.githubusercontent.com/u/92543814?v=4',
		name: 'Tishtanya Shaw',
		role: 'Full-stack developer',
		github: 'https://github.com/TishShaw',
		linkedIn: 'https://www.linkedin.com/in/tishtanya-shaw/',
		website: 'https://tishshaw.vercel.app/',
	},
	{
		image: 'https://avatars.githubusercontent.com/u/57598320?v=4',
		name: 'Dorene St.Marthe',
		role: 'Front-end developer',
		github: 'https://github.com/Dorene-StMarthe',
		linkedIn: 'https://www.linkedin.com/in/dorenestmarthe/',
		website: 'https://dorene-stmarthe.github.io/DoreneS.github.io/',
	},
	{
		image: 'https://avatars.githubusercontent.com/GalacticKnight',
		name: 'Vincent Lau',
		role: 'Front-end Developer',
		github: 'https://github.com/GalacticKnight',
		linkedIn: 'https://www.linkedin.com/in/vincent-lau-cs/',
		website: 'https://vifiles.onrender.com/',
	},
	{
		image:
			'https://media.licdn.com/dms/image/C5603AQHIuLG6zmtjTQ/profile-displayphoto-shrink_200_200/0/1597969299247?e=1714003200&v=beta&t=yv5uyoozPusVwqLK0qyxKrM__YVCbmt2yYYRjOGrDiw',
		name: 'Wilson Chu',
		role: 'Back-end developer',
		github: 'https://github.com/Wilson-Chu',
		linkedIn: 'https://www.linkedin.com/in/chuwilson/',
		website: 'https://wilson-chu.github.io/',
	},
	{
		image: 'https://avatars.githubusercontent.com/u/40072414?v=4',
		name: 'Murat Can Sarkalkan',
		role: 'Back-end developer',
		github: 'https://github.com/muratcansarkalkan',
		linkedIn: 'https://www.linkedin.com/in/muratcansarkalkan/',
		website: 'https://muratcansarkalkan.github.io/',
	},
];
